const state = {
    costcodes:[],
};

const getters = {
    getCostcodes: state => state.costcodes,
};

const actions = {
    setCostcodes: (store, payload) => store.commit("COSTCODES_SET",payload),
};

const mutations = {
    COSTCODES_SET: (state, payload) => state.costcodes = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};